import { useCreateFormSubmission } from '@sunrise-ui/api-client';
import type { FieldResponseInput } from '@sunrise-ui/api/insights';
import { useAuthStore } from '@sunrise-ui/primitives';
import { useCheckoutFormStore } from '../stores/useCheckoutFormStore';

export const useSubmitQuestionnaire = () => {
  const { currentUserId } = useAuthStore();
  const { mutate: submitForm } = useCreateFormSubmission({
    showSnackbars: false,
  });

  const submitQuestionnaire = () => {
    const { questionnaireData } = useCheckoutFormStore.getState();

    if (!questionnaireData?.formId) {
      return;
    }

    const fieldResponses: FieldResponseInput[] = Object.entries(
      questionnaireData.formValues,
    ).map(([fieldId, value]) => ({
      field_id: fieldId,
      value: value,
    }));

    submitForm({
      createFormSubmissionInput: {
        form_id: questionnaireData.formId,
        user_id: currentUserId,
        field_responses: fieldResponses,
      },
    });
  };

  return { submitQuestionnaire };
};
